import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {PaymentProfileSchema} from "./schemas";
import {z} from 'zod';

export enum PaymentProfileStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}

export type PaymentProfile = z.infer<typeof PaymentProfileSchema>

export interface IPaymentProfileTableColumn extends ITableColumn {
    render?: (item: PaymentProfile) => ReactNode;
}
